import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad358d32"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-4" }, "Promotion Time (China Time Zone)", -1))
const _hoisted_2 = { class: "row row-cols-2 g-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-4 mt-4" }, "Language Detail", -1))
const _hoisted_4 = { class: "d-flex gap-4 mb-6" }
const _hoisted_5 = { class: "row row-cols-2 g-5" }
const _hoisted_6 = { class: "w-100" }
const _hoisted_7 = { class: "dialog-footer" }

import { ref, reactive, computed } from "vue";
import type { FormInstance } from "element-plus";
import UploadImage from "./UploadImage.vue";
import "jodit/build/jodit.min.css";
import { JoditEditor } from "jodit-vue";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import { ElLoading } from "element-plus";
import SystemService from "../../../system/services/SystemService";
import { ElNotification } from "element-plus";
import notification from "@/core/plugins/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPromotion',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {

const uploadImageRefs = ref<any>({});
const uploadPdfRefs = ref<any>({});
const dialogRef = ref(false);
const isSubmitting = ref(false);
const isLoading = ref(false);

const collapse = ref("1");
const promotionListId = ref(0);
const s3BucketPrefix = ref(
  "https://bcrpropublic.s3.ap-southeast-1.amazonaws.com"
);


const formData = reactive({
  from: null,
  to: null,
});

const data = ref<any>({
  contents: {
    "en-us": {
      title: "",
      content: "",
      coverImage: "",
      pdfUrl: "",
    },
  },
});
const selectedLanguage = ref("en-us");
const canAddLang = computed(() => {
  return Object.keys(data.value.contents).includes(selectedLanguage.value);
});

const updateImage = (lang, url) => {
  data.value.contents[lang].coverImage = url;
};

const updatePdf = (lang, url) => {
  data.value.contents[lang].pdfUrl = url;
};

const submit = async () => {
  const validation = validateFormData();

  if (!validation.isValid) {
    // Display error messages
    validation.errors.forEach((error) => {
      ElNotification.error({
        title: "Validation Error",
        message: error,
        duration: 5000,
      });
    });
    return;
  }

  const loading = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  try {
    for (const lang in data.value.contents) {
      const langData = data.value.contents[lang];
      if (uploadImageRefs.value[lang] && langData.coverImage) {
        if (!langData.coverImage.includes(s3BucketPrefix.value)) {
          await uploadImageRefs.value[lang].uploadImage();
        }
        if (uploadImageRefs.value[lang].returnUrl) {
          langData.coverImage = uploadImageRefs.value[lang].returnUrl;
        }
      }
      if (uploadPdfRefs.value[lang] && langData.pdfUrl) {
        if (!langData.pdfUrl.includes(s3BucketPrefix.value)) {
          await uploadPdfRefs.value[lang].uploadImage();
        }
        if (uploadPdfRefs.value[lang].returnUrl) {
          langData.pdfUrl = uploadPdfRefs.value[lang].returnUrl;
        }
      }
    }
    const finalData = {
      ...formData,
      contents: data.value.contents,
    };
    console.log("finalData", finalData);
    await SystemService.updatePromotionListById(
      promotionListId.value,
      finalData
    );
    emits("submit");
    notification.success();
    resetData();
    dialogRef.value = false;
  } catch (error) {
    console.error(error);
    notification.danger();
  } finally {
    loading.close();
  }
};

const addLang = () => {
  if (Object.keys(data.value.contents).length < LanguageTypes.all.length) {
    data.value.contents[selectedLanguage.value] = {
      title: "",
      content: "",
      coverImage: "",
      pdfUrl: "",
    };
  }
};

const show = async (item) => {
  dialogRef.value = true;
  promotionListId.value = item.id;
  await fecthData();
};

const fecthData = async () => {
  isLoading.value = true;

  try {
    const res = await SystemService.queryPromotionListById(
      promotionListId.value
    )
      .then((res) => {
        data.value.contents = res.data.contents;
        formData.from = res.data.from;
        formData.to = res.data.to;
      })
      .then(() => {
        fetchImages(data.value.contents);
      })
      .then(() => {
        selectedLanguage.value = "en-us";
      });
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const fetchImages = async (contents) => {
  for (const lang in contents) {
    selectedLanguage.value = lang;
    const langData = contents[lang];
    if (langData.coverImage) {
      uploadImageRefs.value[lang].imageUrl = langData.coverImage;
    }

    if (langData.pdfUrl) {
      uploadPdfRefs.value[lang].imageUrl = langData.pdfUrl;
      uploadPdfRefs.value[lang].type = "application/pdf";
    }
  }
};

const resetData = () => {
  formData.from = null;
  formData.to = null;
  data.value.contents = {
    "en-us": {
      title: "",
      content: "",
      coverImage: "",
      pdfUrl: "",
    },
  };
  selectedLanguage.value = "en-us";
};

const ruleFormRef = ref<FormInstance>();
const rules = reactive<any>({
  from: [
    { required: true, message: "Please select start date", trigger: "change" },
  ],
  to: [
    { required: true, message: "Please select end date", trigger: "change" },
  ],
});

const setMonth = (month: number) => {
  const currentDate = new Date();

  // Calculate the start month (current month + month parameter)
  const startMonth = currentDate.getMonth() + 1;
  const startYear = currentDate.getFullYear() + Math.floor(startMonth / 12);

  // Set from date to first day of the start month at 00:00:00 local time
  const fromDate = new Date(startYear, startMonth % 12, 1, 0, 0, 0);

  // Format as YYYY-MM-DD HH:mm:ss
  formData.from = formatDate(fromDate);

  // Calculate the end month (start month + 1)
  const endMonth = startMonth + month;
  const endYear = startYear + Math.floor(endMonth / 12);

  // Set to date to last day of the end month at 23:59:59 local time
  const toDate = new Date(endYear, endMonth % 12, 0, 23, 59, 59);

  // Format as YYYY-MM-DD HH:mm:ss
  formData.to = formatDate(toDate);
};

// Helper function to format date in YYYY-MM-DD HH:mm:ss format in local timezone
const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const validateFormData = () => {
  const errors = <any>[];

  // Validate dates
  if (!formData.from || !formData.to) {
    errors.push("Please set both from and to dates");
  }

  // Validate language content
  const emptyFields = <any>[];

  // for (const lang in data.value.contents) {
  //   const langData = data.value.contents[lang];

  //   // Check if title is empty
  //   if (!langData.title?.trim()) {
  //     emptyFields.push(`Title for ${lang}`);
  //   }

  //   // Check if content is empty
  //   if (!langData.content?.trim()) {
  //     emptyFields.push(`Content for ${lang}`);
  //   }

  //   // Check if image is empty
  //   if (!langData.coverImage?.trim()) {
  //     emptyFields.push(`Cover image for ${lang}`);
  //   }

  //   // Check if PDF is empty
  //   if (!langData.pdfUrl?.trim()) {
  //     emptyFields.push(`PDF for ${lang}`);
  //   }
  // }

  if (emptyFields.length > 0) {
    errors.push(
      `Please fill in all required fields: ${emptyFields.join(", ")}`
    );
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('action.edit'),
    size: "80%"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.update")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: formData,
          rules: rules,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, {
              modelValue: collapse.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((collapse).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, { name: "1" }, {
                  title: _withCtx(() => [
                    _hoisted_1
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (setMonth(1)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("One Month")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (setMonth(2)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Two Months")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_form_item, {
                        label: "from",
                        prop: "from"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: formData.from,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.from) = $event)),
                            type: "datetime",
                            placeholder: "Start Date",
                            "value-format": "YYYY-MM-DD HH:mm:ss",
                            format: "YYYY-MM-DD HH:mm:ss",
                            disabled: isSubmitting.value
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "to",
                        prop: "to"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: formData.to,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.to) = $event)),
                            type: "datetime",
                            placeholder: "End Date",
                            "value-format": "YYYY-MM-DD HH:mm:ss",
                            format: "YYYY-MM-DD HH:mm:ss",
                            disabled: isSubmitting.value
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_select, {
              modelValue: selectedLanguage.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedLanguage).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LanguageTypes).all, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.code,
                    label: item.code + '   (' + item.name + ')',
                    value: item.code
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: addLang,
            disabled: canAddLang.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.addALanguage")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode(_component_el_tabs, {
          type: "card",
          modelValue: selectedLanguage.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedLanguage).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "ruleFormRef",
              ref: ruleFormRef,
              model: formData,
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.contents, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_tab_pane, {
                    label: index,
                    name: index,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.title'),
                        prop: "title"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: item.title,
                            "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                            disabled: isSubmitting.value
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 2
                      }, 1032, ["label"]),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_el_form_item, {
                          label: _ctx.$t('action.uploadImage'),
                          prop: "image"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(UploadImage, {
                              ref_for: true,
                              ref: 
                    (el) => {
                      if (el) uploadImageRefs.value[index] = el;
                    }
                  ,
                              onImageUploaded: ($event: any) => (updateImage(index, $event))
                            }, null, 8, ["onImageUploaded"])
                          ]),
                          _: 2
                        }, 1032, ["label"]),
                        _createVNode(_component_el_form_item, {
                          label: "PDF",
                          prop: "pdf"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(UploadImage, {
                              ref_for: true,
                              ref: 
                    (el) => {
                      if (el) uploadPdfRefs.value[index] = el;
                    }
                  ,
                              accept: "application/pdf",
                              onImageUploaded: ($event: any) => (updatePdf(index, $event))
                            }, null, 8, ["onImageUploaded"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.content'),
                        prop: "content"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(JoditEditor), {
                              modelValue: item.content,
                              "onUpdate:modelValue": ($event: any) => ((item.content) = $event),
                              disabled: isSubmitting.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    ]),
                    _: 2
                  }, 1032, ["label", "name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])), [
        [_directive_loading, isLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})